import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import Image from "../../components/Image/Image";
import Title from "../../components/Title/Title";

// example image import
import image1 from "../../assets/SUMMER_1.jpg";
import image2 from "../../assets/SUMMER_1A.jpg";
import image3 from "../../assets/SUMMER_2.jpg";
import image4 from "../../assets/SUMMER_2A.jpg";
import image5 from "../../assets/SUMMER_3.jpg";
import image6 from "../../assets/SUMMER_3A.jpg";

import gif1 from "../../assets/gif_1.gif";

const Palette = () => {
  return (
    <div className="container py-4">
      <Title weight={800}>PALETTE AS STRUCTURE</Title>
      <p> This project is a focused exploration of colour palettes through a fixed graphic structure.  Each composition uses the same underlying form, allowing palette to act as the primary variable.</p>

      <div className="mt-4">
        <Image
          src={gif1}
          alt="Project hero image"
        />
        <Image
          src={image1}
          alt="Project hero image"
        />
        <Image
          src={image2}
          alt="Project hero image"
        />
        <Image
          src={image3}
          alt="Project hero image"
        />
        <Image
          src={image4}
          alt="Project hero image"
        />
        <Image
          src={image5}
          alt="Project hero image"
        />
        <Image
          src={image6}
          alt="Project hero image"
        />
      </div>
    </div>
  );
};

export default Palette;
